import React, { useState, useEffect } from 'react'
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '../../firebase/firebase'
import { t } from '../../components/i18n/i18n'
import back from '../../assets/images/elements/archiveHeader.jpg'

const extractVideoId = (link = '') => {
  const m = link.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/)
  return m ? m[1] : null
}

export const WebArchive = () => {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [expandedYears, setExpandedYears] = useState({})

  useEffect(() => {
    getDocs(query(collection(db, 'archive'), orderBy('year', 'desc')))
      .then(snap => {
        setVideos(snap.docs.map(d => ({ id: d.id, ...d.data() })))
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  const handleSearch = e => {
    const val = e.target.value
    setSearchTerm(val)
    if (val) {
      const years = videos.reduce((acc, v) => { acc[v.year] = true; return acc }, {})
      setExpandedYears(years)
    } else {
      setExpandedYears({})
    }
  }

  const toggleYear = year =>
    setExpandedYears(prev => ({ ...prev, [year]: !prev[year] }))

  const term = searchTerm.trim().toLowerCase()
  const filtered = term
    ? videos.filter(v =>
        v.title?.toLowerCase().includes(term) ||
        v.author?.toLowerCase().includes(term) ||
        v.bible?.toLowerCase().includes(term) ||
        String(v.year).includes(term) ||
        v.keywords?.some(k => k.toLowerCase().includes(term))
      )
    : videos

  const byYearAuthor = filtered.reduce((acc, v) => {
    acc[v.year] = acc[v.year] || {}
    acc[v.year][v.author] = acc[v.year][v.author] || []
    acc[v.year][v.author].push(v)
    return acc
  }, {})

  return (
    <section className='blog'>
      <div className='container_100'>
        <div className='backImg15'>
          <img src={back} alt='' />
          <div className='text_container_dark_15_top'>
            <div className='h1_15 margin0'>{t('webArchiveTitle')}</div>
            <center>
              <input
                type='text'
                placeholder={t('search')}
                value={searchTerm}
                onChange={handleSearch}
              />
            </center>
          </div>
        </div>
        <br />

        <div className='container boxItems'>
          {loading && (
            <p style={{ color: '#999', textAlign: 'center', padding: '40px 0' }}>•••</p>
          )}

          {!loading && videos.length === 0 && (
            <p style={{ color: '#999', textAlign: 'center', padding: '40px 0' }}>
              Архів порожній
            </p>
          )}

          {Object.keys(byYearAuthor).sort((a, b) => b - a).map(year => (
            <div className='menuColor' key={year}>
              <h1
                className='webArchiveYearHeader'
                onClick={() => toggleYear(year)}
                style={{ cursor: 'pointer' }}
              >
                {year} {expandedYears[year] ? '−' : '+'}
              </h1>

              {expandedYears[year] && Object.keys(byYearAuthor[year]).sort().map(author => (
                <div key={author}>
                  <h4><u>{author}</u></h4>
                  <ul>
                    {byYearAuthor[year][author].map(v => {
                      const vid = extractVideoId(v.link)
                      return (
                        <li key={v.id}>
                          <a href={v.link} target='_blank' rel='noopener noreferrer'>
                            {v.title}{v.bible ? ` (${v.bible})` : ''}
                          </a>
                          {vid && (
                            <a
                              href={`https://www.youtube.com/watch?v=${vid}`}
                              target='_blank'
                              rel='noopener noreferrer'
                              style={{ marginLeft: '8px', fontSize: '11px', color: '#c00' }}
                            >
                              ▶
                            </a>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                  <br />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <br />
    </section>
  )
}
